import { EmployeeZipVerificationScreen } from '@/components/EmployeeZipVerificationScreen';

export default function EmployeeZipVerification() {
  return <EmployeeZipVerificationScreen />;
}
